import script from "./GlobusDropdownList.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobusDropdownList.vue?vue&type=script&setup=true&lang=js"

import "./GlobusDropdownList.vue?vue&type=style&index=0&id=fa145334&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa145334"]])

export default __exports__